module.exports = __webpack_public_path__ + "static/media/RobertLaMagaReiter.9a1a8a42.jpg";